import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

const short = (d) => new Date(`${d}T12:00:00`).toLocaleDateString(undefined, { month: "short", day: "numeric" });

// THE SHRINKING COUNT — one reading per yard day of containers on no shelf with parts inside; today is live.
export function ShelfCleanupDays({ days, testid = "shelf-days", dark = false }) {
  if (!days || days.length === 0) {
    return <div data-testid={`${testid}-none`} className="text-xs text-slate-500">The day-by-day count starts with the first reading (once an hour).</div>;
  }
  return (
    <div data-testid={testid} className="flex gap-1.5 overflow-x-auto pb-1">
      {days.map((d, i) => {
        const n = d.containers_with_parts + d.lot_crates_with_parts;
        const prev = i > 0 ? days[i - 1].containers_with_parts + days[i - 1].lot_crates_with_parts : null;
        return (
          <div key={d.day} data-testid={`${testid}-${d.day}`}
            className={`shrink-0 rounded-lg border px-2.5 py-1.5 text-center ${dark ? "border-white/20" : "border-slate-200 bg-white"}`}>
            <div className="text-[10px] font-mono uppercase tracking-wider text-slate-500">{short(d.day)}</div>
            <div className="text-base font-black tabular-nums">{n.toLocaleString()}</div>
            {prev !== null && n !== prev && (
              <div className={`text-[10px] font-bold ${n < prev ? "text-emerald-600" : "text-[#B01E28]"}`}>
                {n < prev ? `−${prev - n}` : `+${n - prev}`}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

// Places & Containers: the count and its days, with the way to the crew's checklist.
export function ShelfCleanupStrip() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/shelf-cleanup/summary").then((r) => setS(r.data)).catch(() => setS(null)); }, []);
  if (!s) return null;
  const n = s.now;
  return (
    <div data-testid="shelf-cleanup-strip" className="mb-3 rounded-xl border border-red-100 bg-red-50/50 p-3">
      <div className="text-sm text-slate-800">
        <b data-testid="shelf-cleanup-strip-count">{(n.containers_with_parts + n.lot_crates_with_parts).toLocaleString()}</b> on no shelf with parts inside:
        {" "}{n.containers_with_parts.toLocaleString()} container{n.containers_with_parts === 1 ? "" : "s"} ({n.parts_in_containers.toLocaleString()} parts)
        {" "}and {n.lot_crates_with_parts.toLocaleString()} lot{n.lot_crates_with_parts === 1 ? "" : "s"} ({n.parts_in_lot_crates.toLocaleString()} parts not put away).
        {" "}<Link to="/floor/shelve" data-testid="shelf-cleanup-strip-open" className="font-bold text-[#B01E28] underline">Crew checklist</Link>
      </div>
      <div className="mt-2"><ShelfCleanupDays days={s.days} testid="shelf-cleanup-strip-days" /></div>
    </div>
  );
}
